module.exports = __webpack_public_path__ + "static/media/保腎護心網layout手機物件_08.832a7400.png";